import React, { useState } from "react";
import { Layout, Table, Avatar, Input, Space} from "antd";
import { UserOutlined } from "@ant-design/icons";
import MainLayout from "../../layout/mainlayout.tsx";

const { Content } = Layout;
const { Search } = Input;


interface Client {
  key: number;
  name: string;
  email: string;
  totalTickets: number;
  lastTicketDate: string;
}

const Users: React.FC = () => {
  const initialClients: Client[] = [
    {
      key: 1,
      name: "Bettina Webb",
      email: "bettina@example.com",
      totalTickets: 5,
      lastTicketDate: "2024-09-15",
    },
    {
      key: 2,
      name: "Emma Smith",
      email: "emma@example.com",
      totalTickets: 2,
      lastTicketDate: "2024-09-12",
    },
    {
      key: 3,
      name: "Derrick Mitchell",
      email: "derrick@example.com",
      totalTickets: 8,
      lastTicketDate: "2024-09-10",
    },
    {
      key: 4,
      name: "Viola Greer",
      email: "viola@example.com",
      totalTickets: 3,
      lastTicketDate: "2024-09-20",
    },
  ];

  const [clients] = useState<Client[]>(initialClients);
  const [searchTerm, setSearchTerm] = useState<string>("");

  // Filter clients based on the search term
  const filteredClients = clients.filter(
    (client) =>
      client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      title: "Client",
      dataIndex: "name",
      key: "name",
      render: (text: string) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            style={{ backgroundColor: "#87d068", marginRight: 8 }}
            icon={<UserOutlined />}
          />
          <div>{text}</div>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Total Tickets",
      dataIndex: "totalTickets",
      key: "totalTickets",
    },
    {
      title: "Last Ticket Date",
      dataIndex: "lastTicketDate",
      key: "lastTicketDate",
    },
  ];

  return (
    <MainLayout>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout style={{ padding: "0 24px 24px" }}>
          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              backgroundColor: "#f0f2f5",
              borderRadius: 8,
            }}
          >
            <Space
              direction="vertical"
              style={{
                width: "100%",
                marginBottom: 24,
                textAlign: "center",
              }}
            >
              
              <Search
                placeholder="Search clients by name or email"
                allowClear
                enterButton="Search"
                size="large"
                onSearch={(value) => setSearchTerm(value)}
                style={{ maxWidth: 400, margin: "0 auto" }}
              />
            </Space>

            <Table
              columns={columns}
              dataSource={filteredClients}
              pagination={{
                pageSize: 5,
                showSizeChanger: false,
                total: filteredClients.length,
                showQuickJumper: true,
                hideOnSinglePage: true,
              }}
              rowKey="key"
              bordered
              style={{
                borderRadius: 8,
              }}
            />
          </Content>
        </Layout>
      </Layout>
    </MainLayout>
  );
};

export default Users;
